import { Routes } from '@angular/router';
import { PassportComponent } from './passport.component';
import { OverviewComponent } from './Overview/overview.component';
import { ProvidersComponent } from './Providers/providers.component';
import { ApplicationsComponent } from './applications/applications.component';

export const PASSPORT_ROUTES: Routes = [
    {
        path: "passport",
        component: PassportComponent,
        children: [
            { path: "", redirectTo: "overview", pathMatch: "full" },
            { path: "providers", component: ProvidersComponent },
            { path: "overview", component: OverviewComponent },
            { path: "applications", component: ApplicationsComponent }
        ]
    }
];